// extracted by mini-css-extract-plugin
module.exports = {"Skills":"Skills_Skills__f0UM1","anim":"Skills_anim__2_U_S","SkillBox":"Skills_SkillBox__ao0P1"};